var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "transparent",
                  attrs: { flat: "", height: "46" },
                },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass:
                        "px-5 subtitle-2 grey-500--text font-weight-bold",
                    },
                    [_vm._v("Configuración de POS")]
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-5 py-4" },
                [
                  !_vm.$helpers.hasPermission(["view_pos"])
                    ? _c("PermissionDenied", { attrs: { isDetail: true } })
                    : [
                        _vm.loadingConfig
                          ? _c("v-skeleton-loader", {
                              attrs: {
                                transition: "fade-transition",
                                type: "list-item-three-line",
                              },
                            })
                          : [
                              _vm._l(_vm.configList, function (config, index) {
                                return _c(
                                  "v-row",
                                  { key: index, attrs: { "no-gutters": "" } },
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "4" } },
                                      [
                                        _c(
                                          "v-list",
                                          {
                                            staticClass:
                                              "v-list-form-extended transparent pa-0",
                                          },
                                          [
                                            _c(
                                              "v-list-item",
                                              { staticClass: "pa-0" },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v("Nombre"),
                                                ]),
                                                _c("v-list-item-subtitle", [
                                                  _vm._v(_vm._s(config.name)),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "5" } },
                                      [
                                        _c(
                                          "v-list",
                                          {
                                            staticClass:
                                              "v-list-form-extended transparent pa-0",
                                          },
                                          [
                                            _c(
                                              "v-list-item",
                                              { staticClass: "pa-0" },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v("Creado el"),
                                                ]),
                                                _c("v-list-item-subtitle", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("dateTimeSecond")(
                                                        config.created
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { staticClass: "px-0" },
                                      [
                                        _c(
                                          "v-list",
                                          {
                                            staticClass:
                                              "v-list-form-extended transparent pa-0",
                                          },
                                          [
                                            _c(
                                              "v-list-item",
                                              {
                                                staticClass:
                                                  "pa-0 green-500--text body-2",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handlerViewConfig(
                                                      config
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Ver configuración")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              _c(
                                "v-col",
                                { staticClass: "pa-0 pt-1" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        text: "",
                                        color: "grey-900",
                                        ripple: false,
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.dialogGroup = true
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { "x-small": "" } },
                                        [_vm._v("mdi-plus")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "font-weight-medium body-1",
                                        },
                                        [
                                          _vm._v(
                                            "Agregar otro grupo de configuración"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                      ],
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "v-card",
            { staticClass: "mt-5 d-none", attrs: { flat: "" } },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "transparent",
                  attrs: { flat: "", height: "46" },
                },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass:
                        "px-5 subtitle-2 grey-500--text font-weight-bold",
                    },
                    [_vm._v("Envío de LOGS")]
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-5 py-4" },
                [
                  _vm.loadingEmails
                    ? _c("v-skeleton-loader", {
                        attrs: {
                          transition: "fade-transition",
                          type: "list-item-three-line",
                        },
                      })
                    : _c(
                        "v-list",
                        {
                          staticClass: "v-list-form-extended transparent pa-0",
                        },
                        [
                          _c(
                            "v-list-item",
                            { staticClass: "pa-0" },
                            [
                              _c("v-list-item-title", [
                                _vm._v("Envio de LOGS por mail"),
                              ]),
                              _c(
                                "v-list-item-subtitle",
                                [
                                  _c("v-switch", {
                                    staticClass: "mt-n4",
                                    staticStyle: { position: "absolute" },
                                    attrs: {
                                      color: "green-500",
                                      dense: "",
                                      ripple: false,
                                    },
                                    model: {
                                      value: _vm.disable_sending,
                                      callback: function ($$v) {
                                        _vm.disable_sending = $$v
                                      },
                                      expression: "disable_sending",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._l(
                            _vm.instance.emails,
                            function (notification, i) {
                              return _c(
                                "v-list-item",
                                { key: notification, staticClass: "my-n4" },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Correo de notificación"),
                                  ]),
                                  _c(
                                    "v-list-item-subtitle",
                                    { staticClass: "d-flex align-center" },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          attrs: {
                                            align: "center",
                                            "no-gutters": "",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticStyle: { width: "180px" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "d-inline-block text-truncate",
                                                  staticStyle: {
                                                    "max-width": "180px",
                                                  },
                                                },
                                                [_vm._v(_vm._s(notification))]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-list-item-action",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    icon: "",
                                                    color: "grey-700",
                                                    ripple: false,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.instance.emails.splice(
                                                        i,
                                                        1
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("mdi-delete"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          _vm._l(_vm.emailsList, function (d, i) {
                            return _c(
                              "v-list-item",
                              { key: i, staticClass: "pa-0" },
                              [
                                _c("v-list-item-title", [_vm._v("Email")]),
                                _c(
                                  "v-list-item-subtitle",
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0",
                                        attrs: {
                                          "no-gutters": "",
                                          align: "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "py-1 pr-2",
                                            attrs: { cols: "8" },
                                          },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                error:
                                                  _vm.$v.emailsList.$each[i]
                                                    .email.$error,
                                                "hide-details": "",
                                                maxlength: "254",
                                                outlined: "",
                                                "single-line": "",
                                                dense: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.$v.emailsList.$each[i]
                                                    .email.$model,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.$v.emailsList.$each[i]
                                                      .email,
                                                    "$model",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression:
                                                  "$v.emailsList.$each[i].email.$model",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item-action",
                                          { staticClass: "ma-0" },
                                          [
                                            i >= 1 || _vm.emailsList.length > 1
                                              ? _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      icon: "",
                                                      color: "red",
                                                      ripple: false,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.emailsList.splice(
                                                          i,
                                                          1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      { attrs: { small: "" } },
                                                      [_vm._v("mdi-close")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          _c(
                            "v-col",
                            { staticClass: "pa-0 pt-1" },
                            [
                              _vm.emailsList.length +
                                ((_vm.instance || {}).emails || []).length <
                              8
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        text: "",
                                        color: "grey-900",
                                        ripple: false,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.addRowEmails.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { "x-small": "" } },
                                        [_vm._v("mdi-plus")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "font-weight-medium body-1",
                                        },
                                        [_vm._v("Agregar otro mail")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-4" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: { outlined: "" },
                      on: { click: _vm.handlerCancel },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: { color: "grey-900", loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          Object.prototype.hasOwnProperty.call(
                            _vm.instance,
                            "xml_store_path"
                          )
                            ? _vm.updatedEmails()
                            : _vm.sendEmails()
                        },
                      },
                    },
                    [_vm._v("Guardar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
            scrollable: "",
          },
          model: {
            value: _vm.dialogGroup,
            callback: function ($$v) {
              _vm.dialogGroup = $$v
            },
            expression: "dialogGroup",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.modeView || _vm.isClone
                                ? "Configuración POS"
                                : "Agregar otro"
                            )
                          ),
                        ]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ml-3",
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      ;(_vm.dialogGroup = false),
                                        _vm.clearInput()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                {
                  staticClass: "py-4 px-0",
                  attrs: { id: "container" },
                  on: { scroll: _vm.onScroll },
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "v-col",
                        { staticClass: "py-0 px-5" },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v("Nombre"),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              error: _vm.$v.config.name.$error,
                              readonly: _vm.modeView,
                              required: "",
                              outlined: "",
                              "single-line": "",
                              dense: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.$v.config.name.$model,
                              callback: function ($$v) {
                                _vm.$set(_vm.$v.config.name, "$model", $$v)
                              },
                              expression: "$v.config.name.$model",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("v-divider", { staticClass: "my-5" }),
                      _c(
                        "span",
                        {
                          staticClass:
                            "px-5 pb-5 d-block font-weight-semibold grey-700--text subtitle-2",
                        },
                        [_vm._v("Tipo de documento")]
                      ),
                      _vm._l(_vm.documentTypeList, function (d, i) {
                        return _c(
                          "v-row",
                          {
                            key: i,
                            class: [`px-5 pb-2`, { "pb-0": !_vm.modeView }],
                            attrs: { "no-gutters": "" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "pa-0 pr-4",
                                attrs: {
                                  cols:
                                    _vm.documentTypeList.length > 0 ? "25%" : 6,
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "grey-500--text body-1" },
                                  [_vm._v("Tipo de documento")]
                                ),
                                _c("v-autocomplete", {
                                  attrs: {
                                    error:
                                      _vm.$v.documentTypeList.$each[i].type
                                        .$error,
                                    "append-icon": "mdi-chevron-down",
                                    readonly: _vm.modeView,
                                    label: "Selecciona un tipo de documento",
                                    items: _vm.documentTypes.filter(
                                      ({ country }) =>
                                        country ===
                                        _vm.$store?.state?.auth?.account
                                          ?.country
                                    ),
                                    "item-value": "id",
                                    "item-text": "name",
                                    "menu-props": {
                                      overflowY: true,
                                      transition: "slide-y-transition",
                                    },
                                    height: "30",
                                    "single-line": "",
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "item",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "font-weight-regular",
                                              },
                                              [_vm._v(_vm._s(data.item.name))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value:
                                      _vm.$v.documentTypeList.$each[i].type
                                        .$model,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.$v.documentTypeList.$each[i].type,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.documentTypeList.$each[i].type.$model",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "pa-0 pr-2",
                                attrs: { cols: "3" },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "grey-500--text body-1" },
                                  [_vm._v("Cantidad")]
                                ),
                                _c("v-text-field", {
                                  attrs: {
                                    error:
                                      _vm.$v.documentTypeList.$each[i]
                                        .quantities.$error,
                                    readonly: _vm.modeView,
                                    oninput:
                                      "this.value=this.value.replace(/[^0-9.]/g,'');",
                                    outlined: "",
                                    required: "",
                                    "single-line": "",
                                    dense: "",
                                    maxlength: "100",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value:
                                      _vm.$v.documentTypeList.$each[i]
                                        .quantities.$model,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.$v.documentTypeList.$each[i]
                                          .quantities,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.documentTypeList.$each[i].quantities.$model",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "pa-0 pl-2",
                                attrs: { cols: "3" },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "grey-500--text body-1" },
                                  [_vm._v("Umbral")]
                                ),
                                _c("v-text-field", {
                                  attrs: {
                                    error:
                                      _vm.$v.documentTypeList.$each[i]
                                        .thresholds.$error,
                                    readonly: _vm.modeView,
                                    oninput:
                                      "this.value=this.value.replace(/[^0-9.]/g,'');",
                                    outlined: "",
                                    required: "",
                                    "single-line": "",
                                    dense: "",
                                    maxlength: "100",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value:
                                      _vm.$v.documentTypeList.$each[i]
                                        .thresholds.$model,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.$v.documentTypeList.$each[i]
                                          .thresholds,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.documentTypeList.$each[i].thresholds.$model",
                                  },
                                }),
                              ],
                              1
                            ),
                            !_vm.modeView
                              ? _c(
                                  "v-list-item-action",
                                  { staticStyle: { "min-width": "5%" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ml-4 mt-1",
                                        attrs: {
                                          text: "",
                                          color: "grey-700",
                                          ripple: false,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.documentTypeList.splice(
                                              i,
                                              1
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("mdi-delete"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      !_vm.modeView
                        ? _c(
                            "v-col",
                            { staticClass: "pt-2 pb-2 mt-n5" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    text: "",
                                    color: "grey-900",
                                    ripple: false,
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.addRowdDcumentTypeList.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { "x-small": "" } }, [
                                    _vm._v("mdi-plus"),
                                  ]),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "font-weight-medium body-1",
                                    },
                                    [_vm._v("Agregar tipo de documento")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("v-divider"),
                      _c(
                        "v-row",
                        {
                          staticClass: "px-5 pt-5 pb-2",
                          attrs: { "no-gutters": "" },
                        },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pa-0 pr-4", attrs: { cols: "6" } },
                            [
                              _c(
                                "span",
                                { staticClass: "grey-500--text body-1" },
                                [_vm._v("Tamaño de lote")]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  error: _vm.$v.config.batch_size.$error,
                                  readonly: _vm.modeView,
                                  oninput:
                                    "this.value=this.value.replace(/[^0-9.]/g,'');",
                                  required: "",
                                  outlined: "",
                                  "single-line": "",
                                  dense: "",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.$v.config.batch_size.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.config.batch_size,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.config.batch_size.$model",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pa-0 pr-2", attrs: { cols: "3" } },
                            [
                              _c(
                                "span",
                                { staticClass: "grey-500--text body-1" },
                                [_vm._v("Timeout de lote")]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  error: _vm.$v.config.batch_timeout.$error,
                                  readonly: _vm.modeView,
                                  oninput:
                                    "this.value=this.value.replace(/[^0-9.]/g,'');",
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "100",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.$v.config.batch_timeout.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.config.batch_timeout,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.config.batch_timeout.$model",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pa-0 pl-2", attrs: { cols: "3" } },
                            [
                              _c(
                                "span",
                                { staticClass: "grey-500--text body-1" },
                                [_vm._v("Intervalo de lote")]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  error: _vm.$v.config.batch_interval.$error,
                                  readonly: _vm.modeView,
                                  oninput:
                                    "this.value=this.value.replace(/[^0-9.]/g,'');",
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "100",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.$v.config.batch_interval.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.config.batch_interval,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.config.batch_interval.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider", { staticClass: "my-4" }),
                      _c(
                        "v-col",
                        { staticClass: "py-0 px-5" },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v("Timeout de certificado"),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              error: _vm.$v.config.cert_timeout.$error,
                              readonly: _vm.modeView,
                              oninput:
                                "this.value=this.value.replace(/[^0-9.]/g,'');",
                              required: "",
                              outlined: "",
                              "single-line": "",
                              dense: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.$v.config.cert_timeout.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.config.cert_timeout,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.config.cert_timeout.$model",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("v-divider", { staticClass: "my-4" }),
                      _c(
                        "v-col",
                        { staticClass: "py-0 px-5" },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v("Timeout de configuración"),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              error: _vm.$v.config.conf_timeout.$error,
                              readonly: _vm.modeView,
                              oninput:
                                "this.value=this.value.replace(/[^0-9.]/g,'');",
                              required: "",
                              outlined: "",
                              "single-line": "",
                              dense: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.$v.config.conf_timeout.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.config.conf_timeout,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.config.conf_timeout.$model",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("v-divider", { staticClass: "my-5" }),
                      _c(
                        "span",
                        {
                          staticClass:
                            "px-5 pb-5 d-block font-weight-semibold grey-700--text subtitle-2",
                        },
                        [_vm._v("Mensajes de reintento")]
                      ),
                      _c(
                        "v-row",
                        {
                          staticClass: "px-5 pb-6",
                          attrs: { "no-gutters": "" },
                        },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pa-0 pr-2", attrs: { cols: "6" } },
                            [
                              _c(
                                "span",
                                { staticClass: "grey-500--text body-1" },
                                [_vm._v("Intervalo reitento")]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  error: _vm.$v.config.msgretry_interval.$error,
                                  placeholder: "Segundos",
                                  readonly: _vm.modeView,
                                  oninput:
                                    "this.value=this.value.replace(/[^0-9.]/g,'');",
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "100",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.$v.config.msgretry_interval.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.config.msgretry_interval,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "$v.config.msgretry_interval.$model",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pa-0 pl-2", attrs: { cols: "6" } },
                            [
                              _c(
                                "span",
                                { staticClass: "grey-500--text body-1" },
                                [_vm._v("Timeout reintento")]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  error: _vm.$v.config.msgretry_timeout.$error,
                                  placeholder: "Segundos",
                                  readonly: _vm.modeView,
                                  oninput:
                                    "this.value=this.value.replace(/[^0-9.]/g,'');",
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "100",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.$v.config.msgretry_timeout.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.config.msgretry_timeout,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "$v.config.msgretry_timeout.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "span",
                        {
                          staticClass:
                            "px-5 pt-5 d-block font-weight-semibold grey-700--text subtitle-2",
                        },
                        [_vm._v("Mensajes de señal de vida")]
                      ),
                      _c(
                        "v-row",
                        {
                          staticClass: "px-5 pt-5 pb-2",
                          attrs: { "no-gutters": "" },
                        },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pa-0 pr-2", attrs: { cols: "6" } },
                            [
                              _c(
                                "span",
                                { staticClass: "grey-500--text body-1" },
                                [_vm._v("Intervalo de señal")]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  error: _vm.$v.config.signal_interval.$error,
                                  placeholder: "Segundos",
                                  readonly: _vm.modeView,
                                  oninput:
                                    "this.value=this.value.replace(/[^0-9.]/g,'');",
                                  required: "",
                                  outlined: "",
                                  "single-line": "",
                                  dense: "",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.$v.config.signal_interval.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.config.signal_interval,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "$v.config.signal_interval.$model",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pa-0 pl-2", attrs: { cols: "6" } },
                            [
                              _c(
                                "span",
                                { staticClass: "grey-500--text body-1" },
                                [_vm._v("Timeout de señal")]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  error: _vm.$v.config.signal_timeout.$error,
                                  placeholder: "Segundos",
                                  readonly: _vm.modeView,
                                  oninput:
                                    "this.value=this.value.replace(/[^0-9.]/g,'');",
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "100",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.$v.config.signal_timeout.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.config.signal_timeout,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.config.signal_timeout.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider", { staticClass: "my-5" }),
                      _c(
                        "v-col",
                        { staticClass: "pt-0 px-5", attrs: { cols: "6" } },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v("Generación PDF"),
                          ]),
                          _c("v-select", {
                            attrs: {
                              error: _vm.$v.config.gen_pdf.$error,
                              items: _vm.genPdfList,
                              "item-text": "text",
                              "item-value": "value",
                              "menu-props": {
                                overflowY: true,
                                transition: "slide-y-transition",
                              },
                              readonly: _vm.modeView,
                              height: "30",
                              "single-line": "",
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.$v.config.gen_pdf.$model,
                              callback: function ($$v) {
                                _vm.$set(_vm.$v.config.gen_pdf, "$model", $$v)
                              },
                              expression: "$v.config.gen_pdf.$model",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "pt-0 px-5", attrs: { cols: "6" } },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v("Codificación de entrada"),
                          ]),
                          _c("v-select", {
                            attrs: {
                              items: _vm.inputEncodingList,
                              "item-text": "text",
                              "item-value": "value",
                              "menu-props": {
                                overflowY: true,
                                transition: "slide-y-transition",
                              },
                              readonly: _vm.modeView,
                              height: "30",
                              "single-line": "",
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.config.input_charset,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "input_charset", $$v)
                              },
                              expression: "config.input_charset",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "py-0 my-3" },
                        [
                          _c(
                            "v-list",
                            {
                              staticClass:
                                "v-list-form-extended transparent pa-0",
                            },
                            [
                              _c(
                                "v-list-item",
                                { staticClass: "pl-2" },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Carpeta compartida"),
                                  ]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _c("v-switch", {
                                        staticClass: "mt-n4",
                                        staticStyle: { position: "absolute" },
                                        attrs: {
                                          error:
                                            _vm.$v.config.shared_folder_enable
                                              .$error,
                                          readonly: _vm.modeView,
                                          color: "green-500",
                                          dense: "",
                                          ripple: false,
                                        },
                                        model: {
                                          value:
                                            _vm.$v.config.shared_folder_enable
                                              .$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.config
                                                .shared_folder_enable,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.config.shared_folder_enable.$model",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "py-0" },
                        [
                          _c(
                            "v-list",
                            {
                              staticClass:
                                "v-list-form-extended transparent pa-0",
                            },
                            [
                              _c(
                                "v-list-item",
                                { staticClass: "pl-2" },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Auto confirmación"),
                                  ]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _c("v-switch", {
                                        staticClass: "mt-n4",
                                        staticStyle: { position: "absolute" },
                                        attrs: {
                                          error:
                                            _vm.$v.config.doc_auto_confirm
                                              .$error,
                                          readonly: _vm.modeView,
                                          color: "green-500",
                                          dense: "",
                                          ripple: false,
                                        },
                                        model: {
                                          value:
                                            _vm.$v.config.doc_auto_confirm
                                              .$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.config.doc_auto_confirm,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.config.doc_auto_confirm.$model",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ]
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-2" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          ;(_vm.dialogGroup = false), _vm.clearInput()
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        loading: _vm.loadingCreateConfig,
                        disabled: !_vm.modeView && _vm.enabledBtn,
                      },
                      on: {
                        click: function ($event) {
                          !_vm.modeView ? _vm.postConfig() : _vm.handlerClone()
                        },
                      },
                    },
                    [_vm._v(_vm._s(!_vm.modeView ? "Guardar" : "Duplicar"))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }